module.exports = __webpack_public_path__ + "static/ticketHossLogo-2106c00ce294e896cf1451adc65832c9.svg";